<template>
  <v-container>
    <AlertBar ref="useAlerts" :md="md"/>
    <v-row justify="center">
      <v-col cols="12" :md="md">
        <slot/>
      </v-col>
    </v-row>
  </v-container>
  <LoadingOverlay :enable="props.loadingOverlay" scroll-strategy="none"/>
</template>

<script setup>
import { ref } from 'vue';
import AlertBar from "./AlertBar.vue";
import LoadingOverlay from "./LoadingOverlay.vue";

const useAlerts = ref(null);
const suppress = ref(false);

const props = defineProps({
  loadingOverlay: {
    type: Boolean,
    default: false,
  },
  md: {
    type: String,
    default: '6',
  }
});

function successAlert(title, msg) {
  if (!suppress.value) {
    window.scrollTo(0, 0);
    useAlerts.value.successAlert(title, msg);
  }
}

function errorAlert(title, msg) {
  if (!suppress.value) {
    window.scrollTo(0, 0);
    useAlerts.value.errorAlert(title, msg);
  }
}

function warningAlert(title, msg) {
  if (!suppress.value) {
    window.scrollTo(0, 0);
    useAlerts.value.warningAlert(title, msg);
  }
}

function suppressAlert(value) {
  suppress.value = Boolean(value);
}

defineExpose({
  successAlert,
  errorAlert,
  warningAlert,
  suppressAlert,
});
</script>

<style scoped>

</style>
